<template>
  <svg width="1440" height="1323" viewBox="0 0 1440 1323" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_f_7236_25883)">
      <rect x="312" y="414" width="817" height="495" rx="247.5" fill="#FFF4EA"/>
    </g>
    <defs>
      <filter id="filter0_f_7236_25883" x="-102" y="0" width="1645" height="1323" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feGaussianBlur stdDeviation="207" result="effect1_foregroundBlur_7236_25883"/>
      </filter>
    </defs>
  </svg>
</template>

<script>
export default {};
</script>
